__turbopack_context__.v({
  "button": "EoVoQa_button",
  "button--icon": "EoVoQa_button--icon",
  "button--icon--selected": "EoVoQa_button--icon--selected",
  "button--inverted": "EoVoQa_button--inverted",
  "button--plain": "EoVoQa_button--plain",
  "button--secondary": "EoVoQa_button--secondary",
  "button--small": "EoVoQa_button--small",
  "button--tertiary": "EoVoQa_button--tertiary",
  "button-wrapper": "EoVoQa_button-wrapper",
  "button__icon-next": "EoVoQa_button__icon-next",
  "button__prefix": "EoVoQa_button__prefix",
  "button__suffix": "EoVoQa_button__suffix",
  "pagination": "EoVoQa_pagination",
  "pagination__item-range": "EoVoQa_pagination__item-range",
});
